//报表中心
export default [{
  path: '/busStatement',
  component: () => import('../pages/statementManage/busStatement.vue'),
  name: 'busStatement',
  title: '班车报表',
  meta: {
    title: '班车报表',
  },
}, {
  path: '/shopStatement',
  component: () => import('../pages/statementManage/shopStatement.vue'),
  name: 'shopStatement',
  title: '商品报表',
  meta: {
    title: '商品报表',
  },
}, {
  path: '/userConsumeStatement',
  component: () => import('../pages/statementManage/userConsumeStatement.vue'),
  name: 'userConsumeStatement',
  title: '用户消费报表',
  meta: {
    title: '用户消费报表',
  },
}, {
  path: '/activityJionStatement',
  component: () => import('../pages/statementManage/activityJionStatement.vue'),
  name: 'activityJionStatement',
  title: '活动参与报表',
  meta: {
    title: '活动参与报表',
  },
}, {
  path: '/takeOutStatement',
  component: () => import('../pages/statementManage/takeOutStatement.vue'),
  name: 'takeOutStatement',
  title: '外卖报表',
  meta: {
    title: '外卖报表',
  },
}, {
  path: '/rechargeDetailsStatement',
  component: () => import('../pages/statementManage/rechargeDetailsStatement.vue'),
  name: 'rechargeDetailsStatement',
  title: '充值提现明细报表',
  meta: {
    title: '充值提现明细报表',
  },
}, {
  path: '/dailyIncomeStatement',
  component: () => import('../pages/statementManage/dailyIncomeStatement.vue'),
  name: 'dailyIncomeStatement',
  title: '每日收入报表',
  meta: {
    title: '每日收入报表',
  },
}, {
  path: '/dailyRechargeWithdrawStatement',
  component: () => import('../pages/statementManage/dailyRechargeWithdrawStatement.vue'),
  name: 'dailyRechargeWithdrawStatement',
  title: '每日充值提现报表',
  meta: {
    title: '每日充值提现报表',
  },
}, {
  path: '/couponWithdrawStatement',
  component: () => import('../pages/statementManage/couponWithdrawStatement.vue'),
  name: 'couponWithdrawStatement',
  title: '卡券核销报表',
  meta: {
    title: '卡券核销报表',
  },
}, {
  path: '/userAnalyseStatement',
  component: () => import('../pages/statementManage/userAnalyseStatement.vue'),
  name: 'userAnalyseStatement',
  title: '客户分析',
  meta: {
    title: '客户分析',
  },
}, {
  path: '/trajectoryAnalysis',
  component: () => import('../pages/statementManage/trajectoryAnalysis.vue'),
  name: '业主在住分析',
  title: '业主在住分析',
  meta: {
    title: '业主在住分析',
  },
}, {
  path: '/restQrcodeStatement',
  component: () => import('../pages/statementManage/restQrcodeStatement.vue'),
  name: 'restQrcodeStatement',
  title: '餐厅扫码日报',
  meta: {
    title: '餐厅扫码日报',
  },
}, {
  path: '/shipReportForm',
  component: () => import('../pages/statementManage/shipReportForm.vue'),
  name: 'shipReportForm',
  title: '船运明细报表',
  meta: {
    title: '船运明细报表',
  },
}, {
  path: '/shipDailyReportForm',
  component: () => import('../pages/statementManage/shipDailyReportForm.vue'),
  name: 'shipDailyReportForm',
  title: '船运日报表',
  meta: {
    title: '船运日报表',
  },
}, {
  path: '/shipDailyReportFormNew',
  component: () => import('../pages/statementManage/shipDailyReportFormNew.vue'),
  name: 'shipDailyReportFormNew',
  title: '船运日报表(新)',
  meta: {
    title: '船运日报表(新)',
  },
}, {
  path: '/ticketReportForm',
  component: () => import('../pages/statementManage/ticketReportForm.vue'),
  name: 'ticketReportForm',
  title: '票务日报表',
  meta: {
    title: '票务日报表',
  },
}, {
  path: '/ticketReportFormNew',
  component: () => import('../pages/statementManage/ticketReportFormNew.vue'),
  name: 'ticketReportFormNew',
  title: '票务日报表',
  meta: {
    title: '票务日报表',
  },
}, {
  path: '/ticketDetailedForm',
  component: () => import('../pages/statementManage/ticketDetailedForm.vue'),
  name: 'ticketDetailedForm',
  title: '票务明细报表',
  meta: {
    title: '票务明细报表',
  },
},

  {
    path: '/goodsReportForm',
    component: () => import('../pages/statementManage/goodsReportForm.vue'),
    name: 'goodsReportForm',
    title: '好物明细报表',
    meta: {
      title: '好物明细报表',
    },
  }, {
    path: '/ticketDailyReportForm',
    component: () => import('../pages/statementManage/ticketDailyReportForm.vue'),
    name: 'ticketDailyReportForm',
    title: '票务统计报表',
    meta: {
      title: '票务统计报表',
    },
  }, {
    path: '/ticketDailyReportFormNew',
    component: () => import('../pages/statementManage/ticketDailyReportFormNew.vue'),
    name: 'ticketDailyReportFormNew',
    title: '票务统计报表',
    meta: {
      title: '票务统计报表',
    },
  }, {
    path: '/activityReportForm',
    component: () => import('../pages/statementManage/activityReportForm.vue'),
    name: 'activityReportForm',
    title: '活动明细报表',
    meta: {
      title: '活动明细报表',
    },
  }, {
    path: '/activityReportFormNew',
    component: () => import('../pages/statementManage/activityReportFormNew.vue'),
    name: 'activityReportFormNew',
    title: '活动明细报表',
    meta: {
      title: '活动明细报表',
    },
  }, {
    path: '/activityDailyReportForm',
    component: () => import('../pages/statementManage/activityDailyReportForm.vue'),
    name: 'activityDailyReportForm',
    title: '活动日报',
    meta: {
      title: '活动日报',
    },
  }, {
    path: '/activityOrderStatement',
    component: () => import('../pages/statementManage/activityOrderStatement.vue'),
    name: 'activityOrderStatement',
    title: '活动订单报表',
    meta: {
      title: '活动订单报表',
    },
  }, {
    path: '/ticketOrderReportForm',
    component: () => import('../pages/statementManage/ticketOrderReportForm.vue'),
    name: 'ticketOrderReportForm',
    title: '票务订单报表',
    meta: {
      title: '票务订单报表',
    },
  }, {
    path: '/ticketOrderReportFormNew',
    component: () => import('../pages/statementManage/ticketOrderReportFormNew.vue'),
    name: 'ticketOrderReportFormNew',
    title: '畅玩票务明细报表',
    meta: {
      title: '畅玩票务明细报表',
    },
  }, {
    path: '/packTicketReportForm',
    component: () => import('../pages/statementManage/packTicketReportForm.vue'),
    name: 'packTicketReportForm',
    title: '套票明细报表',
    meta: {
      title: '套票明细报表',
    },
  }, {
    path: '/productDailyReportForm',
    component: () => import('../pages/statementManage/productDailyReportForm.vue'),
    name: 'productDailyReportForm',
    title: '好物日报表',
    meta: {
      title: '好物日报表',
    },
  }, {
    path: '/funDailyReportForm',
    component: () => import('../pages/statementManage/funDailyReportForm.vue'),
    name: 'funDailyReportForm',
    title: '畅玩日结对账表',
    meta: {
      title: '畅玩日结对账表',
    },
  }, {
    path: '/withdrawalForm',
    component: () => import('../pages/statementManage/withdrawalStatement.vue'),
    name: 'withdrawalForm',
    title: '现金提现报表',
    meta: {
      title: '现金提现报表',
    },
  }, {
    path: '/couponDetailReport',
    component: () => import('../pages/statementManage/couponDetailReport.vue'),
    name: 'couponDetailReport',
    title: '优惠券订单明细报表',
    meta: {
      title: '优惠券订单明细报表',
    },
  }, {
    path: '/withdrawalDetailsReport',
    component: () => import('../pages/statementManage/withdrawalDetailsReport.vue'),
    name: 'withdrawalDetailsReport',
    title: '现金提现明细报表',
    meta: {
      title: '现金提现明细报表',
    },
  }, {
    path: '/wxReconciliation',
    component: () => import('../pages/statementManage/wxReconciliation.vue'),
    name: 'wxReconciliation',
    title: '微信对账报表',
    meta: {
      title: '微信对账报表',
    },
  }, {
    path: '/writeOffReport',
    component: () => import('../pages/statementManage/writeOffReport.vue'),
    name: 'writeOffReport',
    title: '核销明细报表',
    meta: {
      title: '核销明细报表',
    },
  }, {
    path: '/cruiseDetailStatement',
    component: () => import('../pages/statementManage/cruiseDetailStatement.vue'),
    name: 'cruiseDetailStatement',
    title: '船运订单明细报表',
    meta: {
      title: '船运订单明细报表',
    },
  }, {
    path: '/cruiseDetailStatementNew',
    component: () => import('../pages/statementManage/cruiseDetailStatementNew.vue'),
    name: 'cruiseDetailStatementNew',
    title: '船运明细报表',
    meta: {
      title: '船运明细报表',
    },
  }, {
    path: '/cruiseDistributionStatement',
    component: () => import('../pages/statementManage/cruiseDistributionStatement.vue'),
    name: 'cruiseDistributionStatement',
    title: '船运分销报表',
    meta: {
      title: '船运分销报表',
    },
  }, {
    path: '/cruiseCurDailyStatement',
    component: () => import('../pages/statementManage/cruiseCurDailyStatement.vue'),
    name: 'cruiseCurDailyStatement',
    title: '船运单日报表',
    meta: {
      title: '船运单日报表',
    },
  }, {
    path: '/cruiseReceptionStatement',
    component: () => import('../pages/statementManage/cruiseReceptionStatement.vue'),
    name: 'cruiseReceptionStatement',
    title: '接待人次统计报表',
    meta: {
      title: '接待人次统计报表',
    },
  },
  {
    path: '/cruiseReceptionDailyStatement',
    component: () => import('../pages/statementManage/cruiseReceptionDailyStatement.vue'),
    name: 'cruiseReceptionStatement',
    title: '接待人次明细报表',
    meta: {
      title: '接待人次明细报表',
    },
  },
  {
    path: '/cruiseSalesDailyStatement',
    component: () => import('../pages/statementManage/boat/cruiseSalesDailyStatement.vue'),
    name: 'cruiseSalesDailyStatement',
    title: '销售统计明细报表',
    meta: {
      title: '销售统计明细报表',
    },
  },
  {
    path: '/cruiseSalesStatement',
    component: () => import('../pages/statementManage/cruiseSalesStatement.vue'),
    name: 'cruiseSalesStatement',
    title: '销售统计报表',
    meta: {
      title: '销售统计报表',
    },
  }, {
    path: '/parkingDailyStatement',
    component: () => import('../pages/statementManage/parkingDailyStatement.vue'),
    name: 'parkingDailyStatement',
    title: '停车日报表',
    meta: {
      title: '停车日报表',
    },
  }, {
    path: '/consumeDetailStatement',
    component: () => import('../pages/statementManage/memberCard/consumeDetailStatement.vue'),
    name: 'consumeDetailStatement',
    title: '支出明细报表',
    meta: {
      title: '支出明细报表',
    },
  }, {
    path: '/balanceDetailStatement',
    component: () => import('../pages/statementManage/memberCard/balanceDetailStatement.vue'),
    name: 'balanceDetailStatement',
    title: '余额明细报表',
    meta: {
      title: '余额明细报表',
    },
  }, {
    path: '/rechargeDetailStatement',
    component: () => import('../pages/statementManage/memberCard/rechargeDetailStatement.vue'),
    name: 'rechargeDetailStatement',
    title: '充值明细报表',
    meta: {
      title: '充值明细报表',
    },
  }, {
    path: "/productDailyStatementNew",
    component: () => import("../pages/statementManage/productDailyStatementNew.vue"),
    name: "productDailyStatementNew",
    title: "好物日报表(新)",
    meta: {
      title: "好物日报表(新)"
    }
  }, {
    path: "/parkingDetailStatement",
    component: () => import("../pages/statementManage/parkingDetailStatement.vue"),
    name: "parkingDetailStatement",
    title: "停车明细报表",
    meta: {
      title: "停车明细报表"
    }
  }, {
    path: "/funTicketStatementForm",
    component: () => import("../pages/statementManage/funTicketStatementForm.vue"),
    name: "funTicketStatementForm",
    title: "游玩票务报表",
    meta: {
      title: "游玩票务报表"
    }
  },
  {
    path: "/boatCategoryStatement",
    component: () => import("../pages/statementManage/boat/boatCategoryStatement.vue"),
    name: "boatCategoryStatement",
    title: "约船船型报表",
    meta: {
      title: "约船船型报表"
    }
  },
  {
    path: "/funDistributionStatement",
    component: () => import("../pages/statementManage/funDistributionStatement.vue"),
    name: "funDistributionStatement",
    title: "畅玩分销报表",
    meta: {
      title: "畅玩分销报表"
    }
  },
  {
    path: "/expiredOrderStatement",
    component: () => import("../pages/statementManage/expiredOrderStatement.vue"),
    name: "expiredOrderStatement",
    title: "财务失效报表",
    meta: {
      title: "财务失效报表"
    }
  },
  {
    path: "/umbWriteOffStatement",
    component: () => import("../pages/statementManage/umbWriteOffStatement.vue"),
    name: "umbWriteOffStatement",
    title: "中投核销明细报表",
    meta: {
      title: "中投核销明细报表"
    }
  },
  {
    path: "/totalOrder",
    component: () => import("../pages/statementManage/totalOrder.vue"),
    name: "totalOrder",
    title: "财务报表",
    meta: {
      title: "财务报表"
    }
  },
  {
    path: "/logWriteOffStatement",
    component: () => import("../pages/statementManage/logWriteOffStatement.vue"),
    name: "logWriteOffStatement",
    title: "核销明细报表",
    meta: {
      title: "核销明细报表"
    }
  },
];
